<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <div class="bg-white p-3">
          <h5 class="card-title fw-bold mb-0">Query Builder</h5>
        </div>  
      
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="form-group mb-4">
          <label for="data-source" class="form-label">Data Source</label>
          <select 
            id="data-source"
            class="form-select shadow-none fw-semibold rounded-0"
            v-model="selectedDataSourceId"
            >
            <option value="">Select a data source</option>
            <option 
                v-for="(dataSource, index) in qwilrDataSources" 
                :key="index" 
                :value="dataSource.id"
            >
            {{ dataSource.dataSourceName }}
            </option>
          </select>
        </div>
        <div class="form-group mb-4">
          <label for="query" class="form-label">Query</label>
          <textarea
            id="query"
            class="form-control"
            v-model="queryCommand"
            placeholder="Enter query"
            rows="4"
          ></textarea>
        </div>
      <div class="form-buttons">
        <button class="btn btn-primary" @click="addQwilrQueryBuilder" :disabled="isBusy">
          <div v-if="isBusy">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>

              Loading...
          </div>
          <div v-else>
            Save
          </div>
        </button>
      </div>
      </div>  
    </div>

  </template>
  
  <script>
  import { AddQwilrQueryBuilder, GetQwilrQueryBuilderById, GetQwilrDataSources } from '@/core/services/entities/qwilr.service'
  import breadcrumbMixin from '@/mixins/BreadcrumbMixin'
  import { useToast } from 'vue-toastification'
  import Swal from 'sweetalert2';

  export default {
    name: "AddQwilrQueryBuilder",
    components: {
    },
    data() {
      return {
        queryCommand:null,
        isBusy:false,
        qwilrDataSources: [],
        selectedDataSourceId:0,
      };
    },
    mixins: [breadcrumbMixin],
    methods: {
        async addQwilrQueryBuilder(){
            this.isBusy = true;
            const toast = useToast();

            setTimeout(async () => {
              if (this.selectedDataSourceId<=0) {
                toast.error('Data source is required!', { timeout: 3000 });
                this.isBusy = false;
                return false; 
              }


              const payload = 
              { 
                qwilrDefinitionId:this.qwilrDefinitionId, 
                queryCommand:this.queryCommand,
                qwilrDataSourceId:this.selectedDataSourceId
              };
            
              await AddQwilrQueryBuilder(payload)
                      .then(response => {
                      if (response.status === 200) {
                          toast.success('Query added successfully!', {
                          timeout: 2000
                          })
                          this.isBusy = false;
                      }
                      })
                      .catch(ex => {
                          this.isBusy = false;
                          const errorMessage = ex.response?.data || ex.message || "An unknown error occurred";
                          console.log(ex);
                          toast.error(`Failed to add query : ${errorMessage}`, {timeout: 2000,});
                      })
              }, 500);
        },
        async GetQwilrQueryBuilderById() {
            let data = await GetQwilrQueryBuilderById(this.qwilrDefinitionId);
            if(data)
            {
                console.log(data);
                this.queryCommand = data.qwilrQueryBuilder.queryCommand;
                this.selectedDataSourceId = data.qwilrQueryBuilder.qwilrDataSourceId;
            }

        },
        async fetchQwilrDataSources() {
          let data = await GetQwilrDataSources();
          if(data)
          {
            this.qwilrDataSources = data.qwilrDataSources;
          }

        }
    },
    created() {
      this.qwilrDefinitionId = this.$route.params.id;
      this.GetQwilrQueryBuilderById();
      this.fetchQwilrDataSources();
    }
  };
  </script>


  